import React from 'react'
import { Routes, Route } from 'react-router-dom'
import EpicsPage from '../Pages/Epics/EpicsPage'
import EpicDetailsPage from '../Pages/Epics/EpicDetailsPage'
import EpicAnalyticsDashboard from '../Pages/Epics/Analytics/EpicAnalyticsDashboard'

const EpicsRouter: React.FC = () => {
  return (
    <Routes>
      {/* Default route now shows analytics dashboard (trends) */}
      <Route index element={<EpicAnalyticsDashboard />} />
      <Route path="analysis" element={<EpicsPage />} />

      {/* Epic details page without navigation pills */}
      <Route path=':epicKey' element={<EpicDetailsPage />} />
    </Routes>
  )
}

export default EpicsRouter